export default {
  "content": "<style/><path d=\"M472 64H40C17.9 64 0 81.9 0 104v304c0 22.1 17.9 40 40 40h432c22.1 0 40-17.9 40-40V104c0-22.1-17.9-40-40-40zm-8 336H48V223.7c23 17 55.8 41 106.4 77.7C176.2 317.3 213.8 352 256 352c41.7 0 78.2-33.5 101.6-50.6 50.5-36.7 83.4-60.7 106.4-77.7V400zm0-236.1c-22.4 16.9-58.2 43.2-134.6 98.7-17.8 13-49.7 41.4-73.4 41.4-23.6 0-55.5-28.3-73.4-41.4-76.4-55.5-112.2-81.8-134.6-98.7V112h416v51.9z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 512 512"
  }
};